import { MathUtils as a } from "three";
const p = (o) => o.map((t) => t * a.DEG2RAD);
export {
  p as DegToRadV3
};
//# sourceMappingURL=index5.js.map
